export const AUDIENCE_TYPES = {
  MANAGER: 'manager',
  CAMPAIGN_PARTICIPANTS: 'campaign-participants'
}
